export default __webpack_public_path__ + "static/AA081210_Citation_680-0141-04a_540x358-a4b8be482ca7663970255e06ab1fd2a2.jpg";